<template>
  <div class="result">


    <img alt="logo" class="print-only uk-align-right uk-margin-medium-left" src="../assets/logo.png" style="max-width:250px" width="15%">

<div id="mail">
    <h3 class="uk-margin-medium-top uk-padding-remove-top uk-text-uppercase">Reporte de “Pre Calificación”
de solicitud por capacidad de
pago y buró de crédito</h3>
    <p v-if="loading"> <span uk-spinner="ratio:3"></span> </p>
    
    <p>Nombre: {{name}} <br> Fecha de registro: {{date}} </p>
    <div uk-grid class="uk-child-width-1-1 uk-margin-large-top">
        <!-- <div>

    <h3 class="uk-text-uppercase"  >Resultado medición riesgo crediticio:</h3> <p  style="font-size:20px"> {{aprob}}</p>
        </div> -->
        <div>
      <h3 class="uk-text-uppercase">RESULTADO  Capacidad de Pago </h3>

    
      <p style="font-size:20px">
    <span class="print-only">Ingreso total: {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(ing)}} <br>Egresos: {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(egg)}} <br></span>
          Ahorro disponible: {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Saldo disponible'])}} 
      <br> Cuota a pagar: {{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(parseFloat(data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Cuota mensual']))}}
      <br> <b>Capacidad de pago:</b> %{{ data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Relación entre cuota y disponible']}}
      </p>
        </div>
    </div>

    <hr>
    

    <p class="print-only">El otorgamiento de crédito está sujeto a la veracidad de los datos dados de buena fe por el
solicitante, a la información y documentación que para cada dato se requiera, a los informes que
deban entregar las empresas autorizadas para proporcionar informes de crédito, así como la
autorización que deba emitir el comité de crédito de esta institución, por consiguiente el contenido
de la preaprobación no genera ninguna responsabilidad ni obligación a nuestro cargo por la solicitud
realizada.</p>

    </div>
    <div  uk-grid class="uk-child-width-1-3@s no-print">
        <div v-if="!fromMail">
            <div class="uk-margin no-print">
                <p></p>
            <button class="uk-button uk-button-secondary uk-button-large" v-on:click="send">enviar reporte</button>
            </div>
            <p v-if="loading"><span uk-spinner="ratio:3"></span></p>
        </div>
        <div class="uk-margin no-print">
          <button class="uk-button uk-button-secondary uk-button-large" v-on:click="print">imprimir o guardar reporte</button>
            
        </div>
        <div v-if="!fromMail" class="uk-margin no-print">
          <button class="uk-button uk-button-primary uk-button-large" v-on:click="again">Continúe Riesgo
                Crediticio</button>
        </div>

    </div>

        



  </div>
</template>

<script>
export default {
    data: function() {
      return {
        data : {
            '1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES' : {},
            '4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS' : {},
        },
        loading : false,
        mail : '',
        now : String(new Date().getTime()),
        fromMail : false,
        asalariado:this.$score.asalariado,
        date : '',
        name: '',
        ing:0,
        egg:0,
        aprob : '',
        loading : false,
      }
    }, 
    computed: {
      total : function() {
        var tot = 0.0
        var count = 0
        for (var i in this.data){
          if(this.data[i].hasOwnProperty('PUNTAJE TOTAL')){
             tot += parseFloat(this.data[i]['PUNTAJE TOTAL'])
          }
        }
        return tot.toFixed(2)
      },
      color: function() {
        switch (true) {
          case this.total >= 451:
            return "#42f54e"

          case this.total > 401:
            return "#f5e042"

          case this.total > 301:
            return "#f5e042"

          case this.total > 251:
            return "#f59642"

          default:
            return "#f54242"
        }
      },
      text: function() {
        switch (true) {
          case this.total >= 451:
            return "BAJO RIESGO"

          case this.total > 401 :
            return "RIESGO MODERADO"

          case this.total > 301 :
            return "RIESGO MEDIO"

          case this.total > 251:
            return "RIESGO MEDIO ALTO"

          default:
            return "RIESGO ALTO"
        }
      },
    },
    mounted:async function(){
      window.scroll(0,0)
      this.loading = true
        // estas credenciales son públicas 
        // estas credenciales solo tiene acceso a la función pública del correo
        await firebase.auth().signInWithEmailAndPassword('7c@mail.com','TfXX8MjDtwUZv1UUDNXMwmYlQW12')

        if(this.$route.params.id){
          this.now = this.$route.params.id
          await firebase.database().ref('apps/7c/integral/reportes/' + this.$route.params.id).once('value').then(function (s) {
            this.data = s.toJSON()
            sessionStorage.setItem('score', JSON.stringify(this.data))
          }.bind(this))
        }
      

        this.date = new Date(parseInt(this.now)).toLocaleString()
        if(sessionStorage.getItem('score')){
            this.data =  JSON.parse(sessionStorage.getItem('score'))
        }
        
        if(this.data){
            this.name = this.data['name']
            this.ing = this.data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Total Ingresos']
            this.egg = this.data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Total Gastos']
            this.data['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS']['Relación entre cuota y disponible'] >= 100 ? this.aprob = 'Pre Aprobado' : this.aprob = 'No puede pagar, revisar plazo o monto'
            this.data['PUNTAJE TOTAL'] = this.total
            this.data['Porcentaje'] = ((this.total/490)*100).toFixed(2)

      
        }


        this.loading = false
      

    },
    methods:{
      send : async function() {
        if(this.data['5C  CAPITAL O PATRIMONIO']){
          this.loading = true

          firebase.database().ref('apps/7c/integral/reportes/' + this.now).update(this.data)
          if(this.mail){
            var sendMail = firebase.functions().httpsCallable('cincoc') // esta es la función del correo
            var mailData = {
              mail : this.mail,
              res : document.getElementById('mail').innerHTML 
            }
            await sendMail(mailData)
            UIkit.notification('Resultados enviados correctamente','success')
            await firebase.auth().signOut()

          } else {
            UIkit.notification('Debes ingresar una dirección de correo válida','warning')
          }

          
        } else {
          UIkit.notification('No se respondieron todas las preguntas','warning')
          // this.$router.push('/')
        }
        this.loading = false
      },
      print : function() {
        window.print()
      },
      again:async function () {
          this.loading = true
          sessionStorage.setItem('id', this.now)
          await firebase.database().ref('apps/7c/integral/reportes/' + this.now).update(this.data)
        this.$router.push('6c')
      },
      makecsv: async function () {

          var csvVals = []
  
          var data = this.data

          var csvCount = 1

          var heads = ['Nombre','Fecha','Ingresos','Egresos','Actividad','Deudor','RFC']
          var res = [ this.data.name, this.date, this.ing, this.egg, this.data.act, this.data.deudor, this.data['RFC'] ]
          

          for (var i in data){
            var index = i
            if(index != 'act' && index != 'asalariado' && index != 'RFC' && index != 'Fecha de nacimiento' && index != 'name'){
              heads.push(i)
              res.push(data[i]['PUNTAJE TOTAL'])
            }
          }

          heads.push(['PUNTAJE TOTAL', 'Porcentaje'])
          res.push([this.total, ((this.total/490)*100).toFixed(2)])


          csvVals.push(heads)

          csvVals.push(res)
          csvCount++

          
          let csvContent = "data:text/csv;charset=utf-8,%EF%BB%BF" 
              + encodeURI(csvVals.map(e => e.join(",")).join("\n"));

          var encodedUri = csvContent;
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", "resultado_7c.csv");
          document.body.appendChild(link); // Required for FF

          link.click(); // This will download the data file.
          
      },
    }
}
</script>
